<nav
  class="navbar navbar-top navbar-expand navbar-dark bg-nhc-default border-bottom"
  id="navbar-main"
>
  <div class="container-fluid">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <!-- Navbar links -->
      <ul class="navbar-nav align-items-center ml-md-auto">
        <li class="nav-item d-xl-none">
          <!-- Sidenav toggler -->
          <div
            class="pr-3 sidenav-toggler sidenav-toggler-dark"
            data-action="sidenav-pin"
            data-target="#sidenav-main"
            (click)="openSidebar()"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </li>
        <li class="nav-item d-sm-none">
          <a class="nav-link" (click)="openSearch()">
            <i class="ni ni-zoom-split-in"></i>
          </a>
        </li>
      </ul>
      <!-- User -->
      <ul class="navbar-nav align-items-center ml-auto ml-md-0">
        <li class="nav-item dropdown" dropdown placement="bottom-right">
          <a class="nav-link pr-0 dropdown-toggle" role="button" dropdownToggle>
            <div class="media align-items-center">
              <span class="avatar avatar-sm rounded-circle">
                <img
                  alt="Image placeholder"
                  src="../../../assets/img/avatar image.jpg"/>
              </span>
              <div class="media-body ml-2 d-none d-lg-block">
                <span style="cursor: pointer" class="mb-0 text-sm  font-weight-bold">{{userfullname}}</span>
              </div>
            </div>
          </a>
          <div
            class="dropdown-menu dropdown-menu-arrow dropdown-menu-right"
            *dropdownMenu
          >
            <div class=" dropdown-header noti-title">
              <h6 class="text-overflow m-0">Welcome!</h6>
            </div>
            <a
              routerLinkActive="active"
              [routerLink]="['/settings/profile']"
              class="dropdown-item"
            >
              <i class="ni ni-single-02"></i> <span>My profile</span>
            </a>
            <div class="dropdown-divider"></div>
            <a style="cursor: pointer" (click)="logout()" class="dropdown-item">
              <i class="fas fa-sign-out-alt"></i> <span>Logout</span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div
  *ngIf="sidenavOpen"
  class="backdrop d-xl-none"
  (click)="toggleSidenav()"
></div>
